import {
  Col,
  Row,
  Tag,
  Card,
  Form,
  Spin,
  Icon,
  Input,
  Modal,
  Steps,
  Button,
  message,
  Divider,
  InputNumber,
} from "antd";
import React, {
  useRef,
  Fragment,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import * as R from "ramda";

import { isFunction } from "@/util";
import { get, post } from "../aliyun-service-api";
import {
  SelectedCard,
  SelectedCardList,
} from "@/containers/Video/widgets/selected-card-list";
import { HexColorPicker } from "@/components/Select/ColorPicker";
import { RatioImage } from "@/containers/Video/widgets/ratio-image";
import { UploadImageByStringUrl } from "@/containers/Video/widgets/upload-resource";
import { SelectHeaderAndTail } from "@/containers/Video/widgets/select-header-and-tail";

const resolvePromise = () => Promise.resolve();

export const addHttpsToUrlIfHasNotProtocol = (url) => {
  if (/^http/.test(url)) {
    return url;
  }
  return `https:${url}`;
};

// const VideoRatioTypes = {
//   High: {
//     label: "模版画幅 9:16",
//     key: "916",
//   },
//   Wide: {
//     label: "模版画幅 16:9",
//     key: "169",
//   },
// };

export const SelectOneTemplate = ({
  orderId,
  children = R.T,
  onCreate = resolvePromise,
}) => {
  const [visible, setVisible] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(true);

  const [current, setCurrent] = useState(0);
  const [name, setName] = useState("");

  const [headAndTailList, setHeadAndTailList] = useState([]);

  const [createLoading, setCreateLoading] = useState(false);

  const [head, tail] = headAndTailList || [];

  const [useHeadAndTail, setUseHeadAndTail] = useState(false);

  useEffect(() => {
    if (!visible) {
      return;
    }
    if (!orderId) {
      return;
    }
    if (templateList.length === 0) {
      // fetch template list
      setLoading(true);
      get(`/api/v2/goldtemplate/order/${orderId}/list`)
        .then(setTemplateList)
        .finally(() => {
          setLoading(false);
        });
    }
  }, [visible, orderId]);

  useEffect(() => {
    if (!visible) {
      setCurrent(0);
      setSelectedRowKeys([]);
      setHeadAndTailList([]);
      setName("");
      setUseHeadAndTail(false);
    }
  }, [visible]);

  const RESOLVERef = useRef();
  const REJECTRef = useRef();

  const open = () => {
    setVisible(true);
    return new Promise((resolve, reject) => {
      RESOLVERef.current = resolve;
      REJECTRef.current = reject;
    });
  };

  useEffect(() => {
    if (!visible) {
      setSelectedRowKeys([]);
      setCreateLoading(false);
    }
  }, [visible]);

  return (
    <Fragment>
      <Modal
        style={{
          zIndex: 10,
        }}
        mask
        maskStyle={{ zIndex: 1031 }}
        width={current === 1 ? 1024 : 860}
        closable={false}
        title={(() => {
          switch (current) {
            case 0:
              return "选择模板";
            case 1:
              return "选择片头片尾";
            case 2:
              return "设置视频名称";
            default:
              return "选择模板";
          }
        })()}
        footer={(() => {
          switch (current) {
            case 0:
              return [
                <Button
                  key="back"
                  onClick={() => {
                    setVisible(false);
                    REJECTRef.current();
                  }}
                >
                  取消
                </Button>,
                <Button
                  key="submit"
                  type="primary"
                  onClick={() => {
                    setUseHeadAndTail(false);
                    setCurrent(2);
                  }}
                  disabled={selectedRowKeys.length === 0}
                >
                  下一步
                </Button>,
                <Button
                  key="step2"
                  type="primary"
                  onClick={() => {
                    setUseHeadAndTail(true);
                    setCurrent(1);
                  }}
                  disabled={selectedRowKeys.length === 0}
                >
                  加片头片尾
                </Button>,
              ];
            case 1:
              return [
                <Button
                  key="back"
                  onClick={() => {
                    setCurrent(0);
                  }}
                >
                  上一步
                </Button>,
                <Button
                  key="submit"
                  type="primary"
                  onClick={() => {
                    setCurrent(2);
                  }}
                  disabled={false}
                >
                  下一步
                </Button>,
              ];
            case 2:
              return [
                <Button
                  key="back"
                  onClick={() => {
                    if (useHeadAndTail) {
                      setCurrent(1);
                    } else {
                      setCurrent(0);
                    }
                  }}
                >
                  上一步
                </Button>,
                <Button
                  key="submit"
                  type="primary"
                  onClick={() => {
                    setCreateLoading(true);
                    onCreate({
                      name,
                      template_id: selectedRowKeys[0],
                      // begin_mov: headAndTailList[0],
                      begin_mov: useHeadAndTail
                        ? R.pathOr(
                            undefined,
                            [0, "aliyun_media_id"],
                            headAndTailList
                          )
                        : undefined,
                      // end_mov: headAndTailList[1],
                      end_mov: useHeadAndTail
                        ? R.pathOr(
                            undefined,
                            [1, "aliyun_media_id"],
                            headAndTailList
                          )
                        : undefined,
                    })
                      .then(() => {
                        setVisible(false);
                        RESOLVERef.current();
                      })
                      .catch(REJECTRef.current)
                      .finally(() => {
                        setCreateLoading(false);
                      });
                  }}
                  disabled={R.pipe(R.defaultTo(""), R.trim, R.isEmpty)(name)}
                >
                  确定
                </Button>,
              ];
            default:
              return [];
          }
        })()}
        maskClosable={false}
        visible={visible}
        onCancel={() => {
          if (current === 0) {
            setVisible(false);
            REJECTRef.current();
            return;
          }
          if (current === 1) {
            setCurrent(current - 1);
          }
          if (current === 2) {
            if (useHeadAndTail) {
              setCurrent(1);
            } else {
              setCurrent(0);
            }
          }
        }}
      >
        <Spin spinning={loading}>
          {(() => {
            switch (current) {
              case 0:
                return (
                  <div
                    style={{
                      maxHeight: 600,
                      overflowY: "auto",
                    }}
                  >
                    <SelectedCardList
                      model
                      selectedRowKeys={selectedRowKeys}
                      setSelectedRowKeys={setSelectedRowKeys}
                      rowKey="id"
                      dataSource={templateList}
                    />
                  </div>
                );
              case 1:
                return (
                  <div>
                    <div
                      style={{
                        marginBottom: 16,
                        backgroundColor: "#f0f2f5",
                        fontWeight: "bold",
                        display: "flex",
                      }}
                    >
                      <div className="flex-x-center p-2" style={{ flex: 1 }}>
                        <span style={{ marginRight: 8 }}>片头:</span>
                        {head ? (
                          <Tag
                            closable
                            onClose={() => {
                              setHeadAndTailList([null, tail]);
                            }}
                          >
                            {head.name}
                          </Tag>
                        ) : (
                          <span>请在下方选择片头</span>
                        )}
                      </div>
                      <div className="flex-x-center p-2" style={{ width: 200 }}>
                        正片
                      </div>
                      <div className="flex-x-center p-2" style={{ flex: 1 }}>
                        <span style={{ marginRight: 8 }}>片尾:</span>
                        {tail ? (
                          <Tag
                            closable
                            onClose={() => {
                              setHeadAndTailList([head, null]);
                            }}
                          >
                            {tail.name}
                          </Tag>
                        ) : (
                          <span>请在下方选择片尾</span>
                        )}
                      </div>
                    </div>
                    <Divider orientation="horizontal" />
                    <div
                      style={{
                        display: "flex",
                      }}
                    >
                      <div className="flex-x-center" style={{ flex: 1 }}>
                        <SelectHeaderAndTail
                          value={headAndTailList[0]}
                          orderId={orderId}
                          onChange={(preId) => {
                            const [_, second] = headAndTailList;
                            setHeadAndTailList([preId, second]);
                          }}
                        />
                      </div>
                      <div
                        className="flex-x-center flex-y-center"
                        style={{ width: 200 }}
                      >
                        <SingleTemplateCard
                          model
                          detail={R.find(R.propEq(selectedRowKeys[0], "id"))(
                            templateList
                          )}
                          selectedRowKeys={selectedRowKeys}
                        />
                      </div>
                      <div className="flex-x-center" style={{ flex: 1 }}>
                        <SelectHeaderAndTail
                          value={headAndTailList[1]}
                          orderId={orderId}
                          onChange={(tailId) => {
                            const [first] = headAndTailList;
                            setHeadAndTailList([first, tailId]);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                );
              default:
                return (
                  <div>
                    <Input
                      placeholder="请输入名称"
                      value={name}
                      disabled={createLoading}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                );
            }
          })()}
        </Spin>
      </Modal>
      {children({ open })}
    </Fragment>
  );
};

/**
 * {
 *   "id": 1,
 *   "order_id": 0,
 *   "name": "默认模板",
 *   "title": "title",
 *   "height": 1600,
 *   "width": 900,
 *   "title_colorstyle": "CS0002-000009",
 *   "subtitle_colorstyle": "CS0002-000009",
 *   "background_img": "https://ice-document-materials.oss-cn-shanghai.aliyuncs.com/test_media/background_v.jpg",
 *   "background_audio": "https://wx1.sinaimg.cn/mw690/67d50555gy1hvmqc0kswwj23b04eoe84.jpg",
 *   "cover_url": "http://luoxuntest.jfoto.cn/1.jpeg",
 *   "subtitle_color": "",
 *   "background_color": "#FF000000",
 *   "sub_y": "",
 *   "sub_x": "",
 *   "video_y": "",
 *   "font_size": 0,
 *   "CreatedAt": "0001-01-01T00:00:00Z",
 *   "UpdatedAt": "0001-01-01T00:00:00Z",
 *   "DeletedAt": null
 * }
 *
 * 可改的:
 *    Name     string `json:"name"  `     //模板名称
 *   CoverUrl string `json:"cover_url" ` //封面图
 *   Height   int64  `json:"height"  `   //输出视频高
 *   Width    int64  `json:"width"  `    //输出视频宽
 *
 *   //TitleColorstyle    string `json:"title_colorstyle"`
 *
 *   SubtitleColor string `json:"subtitle_color"` //字幕颜色
 *   BackgroundImg string `json:"background_img"` // 背景图
 *   FontSize      string `json:"font_size"`      //字体大小
 *   VideoY        string `json:"video_y"`        // 视频y坐标
 *   SubY          string `json:"sub_y"`          //字幕Y坐标
 */
const TemplateForm = forwardRef((props, ref) => {
  const { form, template = {} } = props;

  useImperativeHandle(ref, () => ({
    form,
  }));

  return (
    <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 12 }}>
      <Form.Item label="模板名称">
        {form.getFieldDecorator("name", {
          initialValue: R.pathOr("", ["name"], template),
        })(<Input />)}
      </Form.Item>
      <Form.Item label="封面图">
        {form.getFieldDecorator("cover_url", {
          initialValue: R.pathOr("", ["cover_url"], template),
          getValueFromEvent: addHttpsToUrlIfHasNotProtocol,
        })(<UploadImageByStringUrl {...R.omit(["onChange"])(props)} />)}
      </Form.Item>
      {form.getFieldDecorator("height", {
        initialValue: R.pathOr(0, ["height"], template),
      })(<Input type="number" hidden />)}
      {form.getFieldDecorator("width", {
        initialValue: R.pathOr(0, ["width"], template),
      })(<Input type="number" hidden />)}
      <Form.Item label="字幕颜色">
        {form.getFieldDecorator("subtitle_color", {
          initialValue: R.pathOr("", ["subtitle_color"], template),
        })(<HexColorPicker />)}
      </Form.Item>
      <Form.Item label="分段字体个数" style={{ display: "none" }}>
        {form.getFieldDecorator("segment_font_number", {
          initialValue: R.pathOr(0, ["segment_font_number"], template),
        })(<InputNumber />)}
      </Form.Item>
      <Form.Item label="背景图">
        {form.getFieldDecorator("background_img", {
          initialValue: R.pathOr("", ["background_img"], template),
          getValueFromEvent: addHttpsToUrlIfHasNotProtocol,
        })(<UploadImageByStringUrl {...R.omit(["onChange"])(props)} />)}
      </Form.Item>
      {form.getFieldDecorator("font_size", {
        initialValue: R.pathOr("", ["font_size"], template),
      })(<Input hidden type="number" />)}

      {form.getFieldDecorator("video_y", {
        initialValue: R.pathOr("", ["video_y"], template),
      })(<Input hidden type="number" />)}

      {form.getFieldDecorator("sub_y", {
        initialValue: R.pathOr("", ["sub_y"], template),
      })(<Input hidden type="number" />)}
      {form.getFieldDecorator("id", {
        initialValue: R.pathOr("", ["id"], template),
      })(<Input type="hidden" />)}
      {form.getFieldDecorator("order_id", {
        initialValue: R.pathOr("", ["order_id"], template),
      })(<Input type="hidden" />)}
      {form.getFieldDecorator("title", {
        initialValue: R.pathOr("", ["title"], template),
      })(<Input type="hidden" />)}
      {form.getFieldDecorator("title_colorstyle", {
        initialValue: R.pathOr("", ["title_colorstyle"], template),
      })(<Input type="hidden" />)}
      {form.getFieldDecorator("subtitle_colorstyle", {
        initialValue: R.pathOr("", ["subtitle_colorstyle"], template),
      })(<Input type="hidden" />)}
      {form.getFieldDecorator("background_audio", {
        initialValue: R.pathOr("", ["background_audio"], template),
      })(<Input type="hidden" />)}
      {form.getFieldDecorator("cover_url", {
        initialValue: R.pathOr("", ["cover_url"], template),
      })(<Input type="hidden" />)}
      {form.getFieldDecorator("background_color", {
        initialValue: R.pathOr("", ["background_color"], template),
      })(<Input type="hidden" />)}
      {form.getFieldDecorator("sub_x", {
        initialValue: R.pathOr("", ["sub_x"], template),
      })(<Input type="hidden" />)}
      {form.getFieldDecorator("CreatedAt", {
        initialValue: R.pathOr("", ["CreatedAt"], template),
      })(<Input type="hidden" />)}
      {form.getFieldDecorator("UpdatedAt", {
        initialValue: R.pathOr("", ["UpdatedAt"], template),
      })(<Input type="hidden" />)}
      {form.getFieldDecorator("DeletedAt", {
        initialValue: R.pathOr("", ["DeletedAt"], template),
      })(<Input type="hidden" />)}
    </Form>
  );
});

const AdvanceTemplateForm = Form.create({
  name: "advanced_search",
  onValuesChange: (props, changedValues, allValues) => {
    if (props.onChange) {
      props.onChange(allValues, changedValues);
    }
  },
})(TemplateForm);

export const CreateVideoTemplateModal = (props) => {
  const { children, onCreate = resolvePromise } = props;
  const [visible, setVisible] = useState(false);
  /**
   * {
   *             "id": 1,
   *             "order_id": 0,
   *             "name": "默认模板",
   *             "title": "title",
   *             "height": 1600,
   *             "width": 900,
   *             "title_colorstyle": "CS0002-000009",
   *             "subtitle_colorstyle": "CS0002-000009",
   *             "background_img": "https://ice-document-materials.oss-cn-shanghai.aliyuncs.com/test_media/background_v.jpg",
   *             "background_audio": "https://wx1.sinaimg.cn/mw690/67d50555gy1hvmqc0kswwj23b04eoe84.jpg",
   *             "cover_url": "http://luoxuntest.jfoto.cn/1.jpeg",
   *             "subtitle_color": "",
   *             "background_color": "#FF000000",
   *             "sub_y": "",
   *             "sub_x": "",
   *             "CreatedAt": "0001-01-01T00:00:00Z",
   *             "UpdatedAt": "0001-01-01T00:00:00Z",
   *             "DeletedAt": null
   *         }
   */
  const [templateList, setTemplateList] = useState([]);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [template, setTemplate] = useState({});

  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    setTemplate(R.find(R.propEq(selectedRowKeys[0], "id"))(templateList));
  }, [selectedRowKeys, templateList]);

  const [currentStep, setCurrentStep] = useState(0);

  const RESOLVERef = useRef();
  const REJECTRef = useRef();

  useEffect(() => {
    if (!visible) {
      return;
    }
    if (isEdit) {
      return;
    }
    if (templateList.length === 0) {
      // fetch template list
      get("/api/v2/goldtemplate/global/list").then((list) => {
        setTemplateList(list);
      });
    }
  }, [visible, templateList, isEdit]);

  const open = (templateToModify = {}) => {
    setVisible(true);
    setIsEdit(!R.isEmpty(templateToModify));
    setTemplate(templateToModify);
    if (!R.isEmpty(templateToModify)) {
      setCurrentStep(1);
    }
    return new Promise((resolve, reject) => {
      RESOLVERef.current = resolve;
      REJECTRef.current = reject;
    });
  };

  useEffect(() => {
    if (!visible) {
      setCurrentStep(0);
      setSelectedRowKeys([]);
      setIsEdit(false);
      setTemplate({});
    }
  }, [visible]);

  return (
    <Fragment>
      <Modal
        width={850}
        title={isEdit ? "编辑视频模板" : "创建视频模板"}
        visible={visible}
        footer={[
          <Button
            key="back"
            onClick={() => {
              switch (currentStep) {
                case 0:
                  setVisible(false);
                  REJECTRef.current();
                  break;
                case 1:
                  if (isEdit) {
                    setVisible(false);
                    REJECTRef.current();
                  } else {
                    setCurrentStep(currentStep - 1);
                  }
                  break;
                case 2:
                  setCurrentStep(currentStep - 1);
                  break;
                default:
                  break;
              }
            }}
          >
            {(() => {
              switch (currentStep) {
                case 0:
                  return "取消";
                case 1:
                  if (isEdit) {
                    return "取消";
                  }
                  return "上一步";
                case 2:
                  return "上一步";
                default:
                  return "取消";
              }
            })()}
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={(() => {
              switch (currentStep) {
                case 0:
                  return selectedRowKeys.length === 0;
                case 1:
                  return false;
                case 2:
                  return false;
                default:
                  return false;
              }
            })()}
            onClick={() => {
              if (currentStep === 2) {
                setVisible(false);
                RESOLVERef.current(template);

                onCreate(template)
                  .then(RESOLVERef.current)
                  .catch(REJECTRef.current);
                return;
              }
              setCurrentStep(currentStep + 1);
            }}
          >
            {currentStep === 2 ? "确认" : "下一步"}
          </Button>,
        ]}
        onOk={() => {
          setVisible(false);
          RESOLVERef.current();
        }}
        onCancel={() => {
          setVisible(false);
          REJECTRef.current();
        }}
      >
        <Steps current={currentStep}>
          <Steps.Step
            title="选择模板"
            style={{
              opacity: isEdit ? 0.3 : 1,
            }}
          />
          <Steps.Step title="设置参数" />
          <Steps.Step title={!isEdit ? "创建模板" : "修改模板"} />
        </Steps>
        <div
          style={{
            minHeight: 500,
          }}
        >
          {(() => {
            switch (currentStep) {
              case 0:
                return (
                  <div>
                    <SelectedCardList
                      model
                      selectedRowKeys={selectedRowKeys}
                      setSelectedRowKeys={setSelectedRowKeys}
                      rowKey="id"
                      dataSource={templateList.filter((item) => {
                        return !R.equals(23, R.prop("id", item));
                      })}
                    />
                  </div>
                );
              case 1:
                return (
                  <div
                    style={{
                      paddingTop: 24,
                    }}
                  >
                    <AdvanceTemplateForm
                      template={template}
                      onChange={(values) => {
                        setTemplate(values);
                      }}
                      {...props}
                    />
                  </div>
                );
              case 2:
                return (
                  <div>
                    {R.keys(template).map((key) => {
                      return (
                        <Row key={key}>
                          <Col span={6}>{key}</Col>
                          <Col span={18}>{R.propOr("", key, template)}</Col>
                        </Row>
                      );
                    })}
                  </div>
                );
              default:
                return null;
            }
          })()}
        </div>
      </Modal>
      {isFunction(children)
        ? children({
            open,
          })
        : children}
    </Fragment>
  );
};

export const getTemplateCover = R.pipe(
  R.pathOr("", ["cover_url"]),
  R.replace("http://", "https://")
);

export const SingleTemplateCard = (props) => {
  const item = R.pathOr({}, ["detail"], props);
  const open = R.pathOr(R.F, ["open"], props);
  const shouldShowOpen = !R.equals(open, R.F);
  return (
    <SelectedCard
      extra={
        item.order_id !== 0 &&
        shouldShowOpen && (
          <Icon onClick={() => open(item)} type="edit" theme="twoTone" />
        )
      }
      title={<span style={{ fontSize: 12 }}>{item.name}</span>}
      hoverable
      style={{
        marginRight: 16,
        width: 200,
        marginBottom: 16,
      }}
    >
      <RatioImage
        src={getTemplateCover(item)}
        ratio={240 / 200}
        style={{
          maxWidth: 200,
        }}
      />
    </SelectedCard>
  );
};

export const createOrEditTemplate = (url, params) => {
  const convert_to_number = (value) => Number(value);
  const list = ["video_y", "sub_y", "sub_x", "height", "width", "font_size"];
  const newParams = R.mapObjIndexed((value, key) => {
    if (list.includes(key)) {
      return convert_to_number(value);
    }
    return value;
  })(params);
  return post(url, {
    ...newParams,
  })
    .then(() => {
      message.success("成功");
    })
    .catch(() => {
      message.error("失败");
    });
};

//  page
export const VideoTemplate = (props) => {
  const orderId = R.pathOr("", ["match", "params", "orderid"], props) * 1;

  const [loading, setLoading] = useState(true);
  const [templateList, setTemplateList] = useState([]);
  const [requestId, setRequestId] = useState(0);

  useEffect(() => {
    if (!orderId) {
      setLoading(false);
      return;
    }

    get(`/api/v2/goldtemplate/order/${orderId}/list`)
      .then((list) => {
        setTemplateList(list);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [orderId, requestId]);

  return (
    <Spin spinning={loading}>
      <div className="flex-col">
        <div>
          <CreateVideoTemplateModal
            onCreate={(params) => {
              return createOrEditTemplate(
                `/api/v2/goldtemplate/order/${orderId}/add`,
                { ...params, order_id: orderId }
              );
            }}
            {...props}
          >
            {({ open }) => {
              return (
                <Button
                  onClick={async () => {
                    open().then(() => {
                      setRequestId(R.inc);
                    });
                  }}
                  type="primary"
                  icon="down"
                >
                  创建视频模板
                </Button>
              );
            }}
          </CreateVideoTemplateModal>
        </div>

        <div
          className="mt-4 flex"
          style={{
            flexWrap: "wrap",
          }}
        >
          {(() => {
            if (templateList.length === 0) {
              return <Card>暂无数据</Card>;
            }
            return templateList.map((item) => {
              return (
                <CreateVideoTemplateModal
                  onCreate={(params) => {
                    return createOrEditTemplate(
                      `/api/v2/goldtemplate/update/${item.id}`,
                      { ...params, order_id: orderId }
                    ).then(() => setRequestId(R.inc));
                  }}
                  {...props}
                >
                  {({ open }) => {
                    return (
                      <SingleTemplateCard
                        key={item.id}
                        detail={item}
                        open={R.ifElse(
                          R.equals(0), // 判断 item.order_id 是否为 0
                          R.always(() => {
                            message.info("全局模板不可编辑");
                          }), // 如果是 0，执行该函数
                          R.always(open) // 否则执行 open 函数
                        )(item.order_id)}
                      />
                    );
                  }}
                </CreateVideoTemplateModal>
              );
            });
          })()}
        </div>
      </div>
    </Spin>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Video/tab-pages/video-template.js